// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"649":"79679b1d","787":"bc8ff0de","939":"75f6c4f2"}[chunkId] + ".chunk.js";
};